import { render, staticRenderFns } from "./NewFundRead.vue?vue&type=template&id=0a1f09e6&scoped=true&"
import script from "./NewFundRead.vue?vue&type=script&lang=js&"
export * from "./NewFundRead.vue?vue&type=script&lang=js&"
import style0 from "./NewFundRead.vue?vue&type=style&index=0&id=0a1f09e6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.9.6_kq6vcxhoovkpo5ecbydii27d4a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a1f09e6",
  null
  
)

export default component.exports